(function () {
  var STORAGE_KEY = 'kb_wishlist_v1';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // ignore
    }
  }

 function updateHeaderCount() {
  var list = getWishlist();
  var count = Array.isArray(list) ? list.length : 0;

  document
    .querySelectorAll('[data-kb-wishlist-count], .wishlist-count-bubble')
    .forEach(function(counter) {
      counter.textContent = count;
    });
}


  function syncButtonState(button) {
    var handle = button.getAttribute('data-kb-wishlist-handle');
    var list = getWishlist();
    var inList = list.indexOf(handle) !== -1;

    if (inList) {
      button.classList.add('kb-wishlist-button--active');
      var icon = button.querySelector('.kb-wishlist-button__icon');
      var text = button.querySelector('.kb-wishlist-button__text');
      if (icon) icon.textContent = '♥';
      if (text) text.textContent = 'In favourites';
    } else {
      button.classList.remove('kb-wishlist-button--active');
      var icon2 = button.querySelector('.kb-wishlist-button__icon');
      var text2 = button.querySelector('.kb-wishlist-button__text');
      if (icon2) icon2.textContent = '♡';
      if (text2) text2.textContent = 'Add to favourites';
    }
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);

    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }

    saveWishlist(list);
    updateHeaderCount();
  }

  function initButtons() {
    var buttons = document.querySelectorAll('.kb-wishlist-button');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      syncButtonState(button);

      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-kb-wishlist-handle');
        if (!handle) return;
        toggleWishlist(handle);
        syncButtonState(button);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateHeaderCount();
  });
})();
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('kb_wishlist_v1') || '[]');
  } catch (e) {
    return [];
  }
}


function renderWishlistPage() {
  var grid = document.getElementById('kb-wishlist-grid');
  var empty = document.getElementById('kb-wishlist-empty');
  if (!grid) return; // only run on wishlist page

  var list = getWishlist();

  if (!list.length) {
    if (empty) empty.style.display = 'block';
    grid.innerHTML = '';
    return;
  }

  if (empty) empty.style.display = 'none';

  // Fetch each product JSON and build simple cards
  Promise.all(
    list.map(function(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(r){ return r.json(); })
        .catch(function(){ return null; });
    })
  ).then(function(products){
    products = products.filter(Boolean);

    grid.innerHTML = products.map(function(p){
      var img = (p.featured_image || (p.images && p.images[0])) || '';
      var price = (p.price / 100).toFixed(2);

      return `
        <div class="card-wrapper">
          <a class="full-unstyled-link" href="${p.url}">
            ${img ? `<img src="${img}" alt="${p.title}" style="width:100%;height:auto;">` : ``}
            <div style="padding-top:10px">
              <div>${p.title}</div>
              <div>R ${price}</div>
            </div>
          </a>
        </div>
      `;
    }).join('');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  renderWishlistPage();
});
